// eslint-disable-next-line
type keyValueDataTypes = {
  [key: string]: string;
};

enum SampleEventsEnum {
  RemoveCartEntry = 'RemoveCartEntry',
  UpdateCartEntryQty = 'UpdateCartEntryQty',
  AddToCart = 'AddToCart',
}

export enum MonthFormatEnum {
  Short = 'short',
  Long = 'long',
}

export const OrderStatus = {
  CANCELLED: ['ORDER_CANCELLED'],
  COMPLETED: [],
  ALLOCATED: ['ORDER_PLACED'],
  PREPARE_ORDER: ['ORDER_PREPARING'],
  ORDER_DELIVERED: ['ORDER_DELIVERED'],
  ORDER_COLLECTED_KERRY_711: ['ORDER_COLLECTED_KERRY_711'],
};

export const HYBIRS_ORDER_STATUS: keyValueDataTypes = {
  COMPLETED: 'ORDER_COMPLETED',
  CANCELLED: 'ORDER_CANCELLED',
};

export enum STATUS_THEME {
  GREY = 'grey',
  PURPLE = 'purple',
  SUCCESS = 'success',
}
export enum STATUS_TYPE {
  SUCCESS = 'SUCCESS',
  ORDER_DELIVERED = 'ORDER_DELIVERED',
}
export default SampleEventsEnum;

export const OTHER_REASON_ID = 'TH_OTHER';
export const OTHER_RETURN_REASON_ID = 'TH_OTHERS';

export enum CTAs {
  VIEW_DETAILS = 'VIEW_DETAILS',
  BUY_AGAIN = 'BUY_AGAIN',
  VIEW_SOP = 'VIEW_SOP',
  RETRY_PAYMENT = 'RETRY_PAYMENT',
  PAY_NOW = 'PAY_NOW',
  REQUEST_RETURN = 'REQUEST_RETURN',
  CANCEL_ORDER = 'CANCEL_ORDER',
}

export enum SOURCE_OMS {
  HYBRIS = 'HYBRIS',
  NEXTGEN = 'NEXTGEN',
}

export const ChannelSpecificCheckCTA = [
  {
    sourceOms: SOURCE_OMS.HYBRIS,
    OrderHistoryCTAs: [CTAs.VIEW_DETAILS, CTAs.BUY_AGAIN],
    OrderDetailsCTAs: [CTAs.VIEW_SOP, CTAs.BUY_AGAIN, CTAs.REQUEST_RETURN],
  },
];

export const PostpurchaseConstantData = {
  FREE: 'FREE',
  NumberRegex: /\d/,
};
